import _ from 'lodash';
import React from 'react';
import QRCode from 'qr.js';
import PropTypes from 'prop-types';


export default class EssayBarcode extends React.PureComponent {

    static defaultProps = {
        titleMarginRight: 0,
        titleMarginUp: 0, 
    }
    static propTypes = {
        titleMarginRight: PropTypes.number,
        titleMarginUp: PropTypes.number,
    }

    render() {
        const items = this.props.examination.questions; 

        const pages = (_.maxBy(_.values(items), 'page') || {page: 0}).page + 1;
        console.log("pages!!!!! : "+pages);
        return <span>-
            {_.map(new Array(pages), (__, page) => <div 
                key={page}
                style={{
                    position: 'relative',
                    height: '29.7' + 'cm',
                    width: '100%',
                    minWidth: '21' + 'cm',
                    /*overflow: 'hidden',*/
                    pageBreakAfter: 'always',
                    fontFamily: 'IRANSans' 
                }}>
                <div
                id='sep1'
                    style={{
                        position: 'absolute',
                        bottom: this.props.layout.marginBottom + 'cm', 
                        right: this.props.layout.marginRight + 'cm',
                        width: '90%',
                        height: '0',
                        borderBottom: '.5mm solid black',
                        boxSizing: 'border-box',
                    }}>
                </div>
                {(() => {
                    const qrcode = new QRCode((this.props.id * 100 + page).toString(), {
                        typeNumber: -1,
                        errorCorrectLevel: QRCode.ErrorCorrectLevel['Q'],
                    });
                    const element = <div
                    style={{
                        position: 'absolute',
                        top: '10mm',
                        [page % 2 === 0 ? 'left' : 'right']: '10mm',
                        width: '25mm',
                        height: '25mm',
                    }}>
                        <svg
                        viewBox={`0 0 ${qrcode.modules.length} ${qrcode.modules.length}`}
                        preserveAspectRatio='none'>
                        {_.map(qrcode.modules, (row, y) => _.map(row, (module, x) => <rect
                            x={x}
                            y={y}
                            width='1'
                            height='1'
                            style={{
                                fill: module ? 'black' : 'white',
                            }}
                        />))}
                    </svg>
                    </div>;
                    return element;  
                })()}
                <div
                    style={{
                        fontSize: '.8em',
                        position: 'relative',
                        top: '0',
                        right: page % 2 === 0 ? '0' : '3.5cm',
                    }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '10mm',
                            right: (10+Number(this.props.titleMarginRight))+'mm',
                            width:'100%'
                            
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            نام:
                        </span>
                        &nbsp;
                        {(this.props.student.firstname || '').persian()}&nbsp;
                        {(this.props.student.lastname || '').persian()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '16mm',
                            right: '10mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            شماره دانش‌آموزی:
                        </span>
                        &nbsp;
                        {(this.props.student.national_id || '').persian()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '22mm',
                            right: '10mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            آزمون:
                        </span>
                        &nbsp;
                        {(this.props.examination.title || '').persian()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '28mm',
                            right: '10mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            مدت آزمون:
                        </span>
                        &nbsp;
                        {(this.props.examination.length || '').persian()} دقیقه
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '10mm',
                            right: '95mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            شهر:
                        </span>
                        &nbsp;
                        {(this.props.student.school.city.region_display || '').persian()} -&nbsp;
                        {(this.props.student.school.city.name || '').persian()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '16mm',
                            right: '95mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                        حوزه:
                        </span>
                        &nbsp;
                        {(this.props.student.school.name || '').persian()}
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '22mm',
                            right: '95mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            پایه:
                        </span>
                        &nbsp;
                        {(this.props.student.grade.title || '').persian()} -&nbsp;
                        کلاس {(this.props.student.clazz != null ? this.props.student.clazz.name || '' : '').persian()} 
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '28mm',
                            right: '95mm',
                            width:'100%'
                        }}>
                        <span style={{color: '#00AEEF'}}>
                            صفحه:
                        </span>
                        &nbsp;
                        {(page + 1).persian()} از {pages.persian()}
                    </div>
                </div>
                {_.map(_.filter(_.values(items), item => (item.page) === page),
                    // items,

                    item => {
                        const {top, right, width, height, content} = item;
                        const id = item.question_id;
                        console.log('item:',item);
                        return <div
                            key={id}
                            style={{
                                // marginTop:10,
                                position: 'absolute',
                                //1.5 ra bardarim ke box h balater beres
                                top: (top + this.props.layout.marginTop+1.5) + 'cm',
                                right: right + this.props.layout.marginRight + 'cm',
                                width: '90%',
                                height: height!==null?(height + 'cm'):undefined,
                                border: '.5mm solid black',
                                boxSizing: 'border-box',
                                backgroundColor: 'white',
                            }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: this.props.layout.padding + 'cm',
                                    left: '100%',
                                    marginLeft: '2mm',
                                    fontWeight: '700',
                                }}>
                                {(item.index + 1).persian()}.
                            </div>
                            <div
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    overflow: 'hidden',
                                    padding: this.props.layout.padding + 'cm',
                                    boxSizing: 'border-box',
                                }}
                                dangerouslySetInnerHTML={{__html: content}}
                            />
                        </div>;
                    },
                )}
            </div>)}
            {pages % 2 === 1
                ? <div
                    style={{
                        position: 'relative',
                        height: '29.7' + 'cm',
                        width: '100%',
                        minWidth: '21' + 'cm',
                        overflow: 'hidden',
                        marginLeft: '.25em',
                        marginRight: '.25em',
                        pageBreakAfter: 'always',
                    }}>
                </div>
                : null
            }
        </span>;
    }
}
